import { Link } from 'react-router-dom';
import { Footer } from '@/components/Footer';
import { REJECT_REASONS } from '@/lib/reject-reasons';

/**
 * The moderation rules, shown publicly.
 *
 * Same list the moderation UI offers as rejection reasons, from the same
 * module — so a submitter sees the exact bar their pin will be judged against,
 * and a moderator cannot reject for a reason that was never published.
 */
export function RulesPage() {
  return (
    <div className="flex min-h-full flex-col bg-white">
      <main className="mx-auto w-full max-w-3xl flex-1 px-4 py-8">
        <Link to="/" className="text-sm text-brand-700 underline hover:no-underline">
          ← Zpět na mapu
        </Link>

        <h1 className="mt-4 text-2xl font-bold text-slate-900">Pravidla pro podněty</h1>
        <p className="mt-2 text-slate-700">
          Každý podnět před zveřejněním projde kontrolou moderátora. Nejde o cenzuru názorů — mapa
          zveřejňuje i podněty, které kritizují nás. Jde o to, aby mapa zůstala použitelná a aby
          nikoho nepoškodila.
        </p>

        <h2 className="mt-6 text-lg font-semibold text-slate-900">Dobrý podnět</h2>
        <ul className="mt-2 list-disc space-y-1 pl-5 text-slate-700">
          <li>je umístěný na konkrétním místě v Praze,</li>
          <li>popisuje problém, ne osobu,</li>
          <li>je srozumitelný i pro někoho, kdo to místo nezná,</li>
          <li>týká se něčeho, co může město nebo městská část ovlivnit.</li>
        </ul>

        <h2 className="mt-6 text-lg font-semibold text-slate-900">Kdy podnět zamítneme</h2>
        <p className="mt-2 text-slate-700">
          Zamítnout lze <strong>jen</strong> z těchto důvodů. Moderátor musí vždy jeden z nich
          vybrat a volba se zapisuje do auditního záznamu.
        </p>
        <dl className="mt-3 space-y-3">
          {Object.entries(REJECT_REASONS).map(([key, reason]) => (
            <div key={key} className="rounded-md border border-slate-200 p-3">
              <dt className="font-medium text-slate-900">{reason.label}</dt>
              <dd className="mt-1 text-sm text-slate-700">{reason.explanation}</dd>
            </div>
          ))}
        </dl>

        <h2 className="mt-6 text-lg font-semibold text-slate-900">Osobní údaje</h2>
        <p className="mt-2 text-slate-700">
          Toto je nejčastější důvod zamítnutí a stojí za samostatné upozornění. Do podnětu{' '}
          <strong>neuvádějte</strong> jména, adresy konkrétních bytů, registrační značky vozidel,
          popisy jednotlivých lidí ani fotografie osob. Podněty jsou veřejné a takový údaj by
          poškodil někoho, kdo o zveřejnění nežádal.
        </p>
        <p className="mt-2 text-slate-700">
          „Před domem číslo 12 parkuje pan Novák na chodníku“ zamítneme. „Auta pravidelně parkují na
          chodníku a znemožňují průchod s kočárkem“ zveřejníme — je to tentýž problém, popsaný tak,
          aby ho šlo řešit.
        </p>

        <h2 className="mt-6 text-lg font-semibold text-slate-900">Hlasování</h2>
        <p className="mt-2 text-slate-700">
          Podnět lze pouze <strong>podpořit</strong>. Hlas proti neexistuje — ani v aplikaci, ani v
          databázi. Mapa má ukázat, na čem lidem záleží, ne umožnit, aby menšinový problém někdo
          umlčel.
        </p>
        <p className="mt-2 text-slate-700">
          Jeden návštěvník může každý podnět podpořit jednou. Opakované hlasování se nezapočítá.
        </p>

        <h2 className="mt-6 text-lg font-semibold text-slate-900">Nesouhlasíte s rozhodnutím?</h2>
        <p className="mt-2 text-slate-700">
          Napište nám a uveďte, čeho se podnět týkal. Rozhodnutí moderátora rádi znovu posoudíme —
          každé je zaznamenané včetně důvodu, takže jde dohledat.
        </p>

        <p className="mt-6 text-sm text-slate-600">
          Jak nakládáme s údaji, popisují{' '}
          <Link className="underline" to="/soukromi">
            zásady ochrany soukromí
          </Link>
          .
        </p>
      </main>

      <Footer />
    </div>
  );
}
